import type { ComponentType } from 'react';
import { DMHCPAlerts } from '../components/DM/HCPAlerts.js';
import { DMTerritoryInsights } from '../components/DM/TerritoryInsights.js';
import { FRMAccountSearchMessage } from '../components/FRM/AccountSearch.js';
import { RepTwoMinuteSummary } from '../components/Rep/TwoMinuteSummary.js';
import { RepTerritoryInsights } from '../components/Rep/TerritoryInsights.js';
import type { CustomResponseProps } from './types.js';

export const CUSTOM_CHAT_RESPONSE_COMPONENTS = {
  'frm-account-search': FRMAccountSearchMessage,
  'rep-territory-insights': RepTerritoryInsights,
  'dm-territory-insights': DMTerritoryInsights,
  'rep-two-minute-summary': RepTwoMinuteSummary,
  'dm-hcp-alerts': DMHCPAlerts,
} satisfies Record<string, ComponentType<CustomResponseProps>>;
